import { FC, Suspense, useEffect, useState } from 'react';
import { useHookstate } from '@hookstate/core';
import { LazyLottieEffectOverlay } from '../../components/LottieEffectOverlay/lazy';
import { LOTTIE_EFFECT_TRIGGERS } from '../../lib/lottie-effect-triggers';
import { lottieEffect, playNextLottieEffect } from '../../stores/chat';

type LoadedEffect = {
    animationData: unknown;
    effectKey: number;
};

export const LottieEffect: FC = () => {
    const $effect = useHookstate(lottieEffect);
    const activeEffect = $effect.activeEffect.value;
    const activeEffectKey = $effect.activeEffectKey.value;
    const [loadedEffect, setLoadedEffect] = useState<LoadedEffect | null>(null);
    const loader = activeEffect
        ? LOTTIE_EFFECT_TRIGGERS[activeEffect]
        : undefined;

    useEffect(() => {
        let cancelled = false;

        setLoadedEffect(null);

        if (!loader) return;

        loader()
            .then((animationData) => {
                if (!cancelled) {
                    setLoadedEffect({
                        animationData,
                        effectKey: activeEffectKey,
                    });
                }
            })
            .catch((error) => {
                if (!cancelled) {
                    console.error('Failed to load Lottie effect', error);
                    playNextLottieEffect();
                }
            });

        return () => {
            cancelled = true;
        };
    }, [activeEffectKey, loader]);

    if (!loadedEffect || loadedEffect.effectKey !== activeEffectKey)
        return null;

    return (
        <Suspense fallback={null}>
            <LazyLottieEffectOverlay
                key={loadedEffect.effectKey}
                animationData={loadedEffect.animationData}
                onComplete={playNextLottieEffect}
            />
        </Suspense>
    );
};
